import type * as React from 'react';

export enum SegmentedControlSizeEnum {
	SMALL = 'sm',
	MEDIUM = 'md',
	LARGE = 'lg',
}

export enum SegmentedControlAppearanceEnum {
	CONTAINED = 'contained',
	CHIPS = 'chips',
}

export type SegmentedControlOption<TValue extends string = string> = {
	value: TValue;
	/** Visible text; leave it out for an icon-only option and give that option an `ariaLabel`. */
	label?: string;
	icon?: React.ReactNode;
	/** Accessible name of the option, required when there is no visible label. */
	ariaLabel?: string;
	disabled?: boolean;
};
